"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CameraSourceSettings = require("./CameraSourceSettings");
Object.keys(_CameraSourceSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CameraSourceSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CameraSourceSettings[key];
    }
  });
});